import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { notification } from '../component/hocs/notification';
import { mainurl } from '../Mainurl';
import axios from 'axios';
import background from './../assets/img/background.png';

import {
  Col, Row, Button, Form, FormGroup, Input, UncontrolledCarousel, Spinner,
  InputGroup, InputGroupText, Label
} from 'reactstrap';

import { FaUser, FaLock, FaEye, FaEyeSlash, FaSignInAlt } from 'react-icons/fa';

import slider_1 from '../assets/img/slider_1.png';
import slider_2 from '../assets/img/slider_2.png';
import slider_3 from '../assets/img/slider_3.png';
import slider_4 from '../assets/img/slider_4.png';

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  useEffect(() => {
    let loginData = sessionStorage.getItem('loginData');
    if (loginData == null) {
      // User not logged in
    } else {
      navigate('/home');
    }
  }, [navigate]);

  const goto_register_page = () => {
    navigate('/register');
  };

  // Enhanced validation function
  const validateForm = () => {
    const newErrors = {};

    if (!userId.trim()) {
      newErrors.userId = 'Username is required';
    } else if (userId.trim().length < 3) {
      newErrors.userId = 'Username must be at least 3 characters';
    }

    if (!password) {
      newErrors.password = 'Password is required';
    } else if (password.length < 4) {
      newErrors.password = 'Password must be at least 4 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle input blur for validation
  const handleBlur = (field) => {
    setTouched(prev => ({ ...prev, [field]: true }));
    validateForm();
  };

  // Enhanced input change handlers
  const handleUserIdChange = (e) => {
    const value = e.target.value;
    setUserId(value);
    if (touched.userId) {
      validateForm();
    }
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    if (touched.password) {
      validateForm();
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const login_handler = async (event) => {
    event.preventDefault();

    // Mark all fields as touched
    setTouched({ userId: true, password: true });

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setErrors({});

    try {
      const postData = [{
        "org_id": "101",
        "login_id": userId.trim(),
        "password": password,
      }];

      const response = await axios({
        method: 'post',
        url: mainurl + 'Master/user_login',
        data: postData,
        headers: { 'Content-Type': 'application/JSON' }
      });

      console.log(response);

      if (response.data.length > 0) {
        const loginData = JSON.stringify(response.data[0]);
        sessionStorage.setItem('loginData', loginData);
        sessionStorage.setItem('org_id', response.data[0].org_id);
        sessionStorage.setItem('user_id', response.data[0].user_code);
        sessionStorage.setItem('user_pass', password);
        sessionStorage.setItem('role', response.data[0].role_code);

        // logo api 

        const logoResponse = await axios({
          method: 'post',
          url: mainurl + 'Master/org_img',
          data: [{ "org_id": response.data[0].org_id, "user_code": response.data[0].user_code, "password": password }],
          headers: { 'Content-Type': 'application/JSON' }
        });

        if (logoResponse.data.length > 0) {
          sessionStorage.setItem('logo', logoResponse.data[0].org_img);
        }
        
        const msg = "Welcome to Veg Box";
        const notify = notification({ message: msg, type: 'success' });
        notify();
        navigate('/home');

      } else {
        const notify = notification({
          message: "Invalid credentials. Please check your username and password.",
          type: 'error',
          time: true
        });
        notify();
      }
    } catch (error) {
      console.error('Login error:', error);
      const notify = notification({
        message: "Login failed. Please try again later.",
        type: 'error',
        time: true
      });
      notify();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row className="d-flex justify-content-center align-items-center br-5"
      style={{
        background: `url(${background})`,
        height: '100vh',
        marginTop: "-70px"
      }}>
      <Col md={10} lg={10}>
        <Row style={{
          backgroundColor: '#FFF',
          borderRadius: '15px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
          overflow: 'hidden'
        }}>
          <Col className="p-0 d-none d-md-block" md={6} lg={8}>
            <UncontrolledCarousel
              items={[
                { altText: '', caption: '', key: 1, src: slider_1 },
                { altText: '', caption: '', key: 2, src: slider_2 },
                { altText: '', caption: '', key: 3, src: slider_3 },
                { altText: '', caption: '', key: 4, src: slider_4 },
              ]}
            />
          </Col>

          <Col className="p-3" md={6} lg={4}>
            <div className="text-center text-primary mb-3 mt-3">
              <img src={require('../assets/img/logo1.png')} alt="Logo" style={{ maxHeight: "80px", maxWidth: "250px" }} />
            </div>
            <div className="text-muted text-center mb-3">
              <b>Agriculture Management System</b>
            </div>

            <Form className="mt-4 mb-4" onSubmit={login_handler} noValidate>
              <div className="text-center pb-4">
                <h4 className="fw-bold text-primary">Welcome Back</h4>
                <small className="text-muted">Please sign in to your account</small>
              </div>

              {/* Enhanced Username Field */}
              <FormGroup className="mb-3">
                <InputGroup size="md">
                  <InputGroupText>
                    <FaUser className='text-primary' />
                  </InputGroupText>
                  <Input
                    type="text"
                    name="userName"
                    placeholder="Enter your username"
                    value={userId}
                    onChange={handleUserIdChange}
                    onBlur={() => handleBlur('userId')}
                    invalid={touched.userId && errors.userId}
                    className={`${touched.userId && errors.userId ? 'is-invalid' : ''} ${touched.userId && !errors.userId && userId ? 'is-valid' : ''
                      }`}
                  />
                </InputGroup>
                {touched.userId && errors.userId && (
                  <div className="invalid-feedback d-block mt-1">
                    <small>{errors.userId}</small>
                  </div>
                )}
              </FormGroup>

              {/* Enhanced Password Field */}
              <FormGroup className="mb-3">
                <InputGroup size="md">
                  <InputGroupText >
                    <FaLock className='text-primary' />
                  </InputGroupText>
                  <Input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={handlePasswordChange}
                    onBlur={() => handleBlur('password')}
                    invalid={touched.password && errors.password}
                  />
                  <InputGroupText
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <FaEye className='text-success' /> : <FaEyeSlash className='text-danger' />}
                  </InputGroupText>
                </InputGroup>
                {touched.password && errors.password && (
                  <div className="invalid-feedback d-block mt-1">
                    <small>{errors.password}</small>
                  </div>
                )}
              </FormGroup>

              {/* Enhanced Login Button */}
              <Button
                size="md"
                color="primary"
                disabled={loading}
                type="submit"
                block
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2">Loading...</Spinner>
                    Signing In...
                  </>
                ) : (
                  <>
                    <FaSignInAlt className='me-2' />
                    Sign In
                  </>
                )}
              </Button>

            </Form>

            {/* <div className="text-center">
              <small className="text-muted">
                Don't have an account? 
                <button 
                  className="btn btn-link btn-sm p-0 ms-1 text-primary fw-bold"
                  onClick={goto_register_page}
                  style={{ textDecoration: 'none' }}
                >
                  Sign up here
                </button>
              </small>
            </div> */}


            <small className="d-block text-muted text-center mt-4">
              Developed by Vegbox
            </small>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Login;